import { RootState } from "../../../redux-store";

export const selectRouting = () => (state: RootState) =>
  state.data.routing?.routing || null;
